/**
 * StellMark — brand wordmark + house silhouette (Plan 01-16, Task 2).
 *
 * The mark renders the same geometry as `StellMark.source.svg` (the
 * file the PWA-icon generator rasterises). Inside React it uses
 * `fill="currentColor"` so a parent class such as `text-primary`
 * (default) or any dusk-mode override tints the entire silhouette.
 *
 * UI-SPEC §Component Inventory pins the contract:
 *   <StellMark size={32} />  →  <svg width=32 height=32 role=img>
 *
 * Phase 1 surfaces (DashboardHeader; mobile greeting card) consume this
 * primitive; Plan 17 visual regression freezes the geometry.
 */
interface StellMarkProps {
  size?: number;
  className?: string;
  title?: string;
}

export function StellMark({
  size = 32,
  className,
  title = 'Stell',
}: StellMarkProps) {
  const cls = ['text-primary', className].filter(Boolean).join(' ');
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 64 64"
      role="img"
      aria-label={title}
      className={cls}
    >
      <title>{title}</title>
      {/* Roof outline (slim ridge-line for visual lift) */}
      <polygon
        points="32,8 8,30 12,30 32,12 52,30 56,30"
        fill="currentColor"
      />
      {/* Roof solid */}
      <polygon points="32,12 8,32 56,32" fill="currentColor" />
      {/* Body */}
      <rect x="14" y="32" width="36" height="24" fill="currentColor" />
      {/* Door — deeper terracotta via opacity overlay so a single colour
          stop tints both layers cleanly under text-* classes */}
      <rect
        x="27"
        y="38"
        width="10"
        height="18"
        fill="currentColor"
        opacity="0.65"
      />
      {/* Window — locked to var(--color-sheet)
          via fill so it stays visible whether the silhouette is tinted
          in either theme */}
      <rect
        x="40"
        y="38"
        width="6"
        height="6"
        fill="var(--color-sheet)"
      />
    </svg>
  );
}
